import React from "react";
import classnames from "classnames";

const Button = ({ children, type, IconComponent, className, disabled = false, ...otherProps }) => {
    const baseClassNames = "block w-full hover:cursor-pointer disabled:bg-gray-100 disabled:cursor-not-allowed rounded-md shadow-sm md:w-auto md:inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 rounded-md focus:border-primary-700 transition ease-in-out duration-150 focus:shadow-outline-primary focus:outline-none";
    const mapping = {
        "primary": "text-white bg-primary-600 hover:bg-primary-700 active:bg-primary-700",
        "ghost": "bg-white border-gray-300 text-gray-700 hover:bg-gray-50",
        "danger": "bg-red-600 border-red-600 text-white hover:bg-red-700"
    };

    let styles = {};

    if (disabled) {
        styles.backgroundColor = "#D1D5DB";
    }

    return (
        <button {...otherProps} className={classnames(baseClassNames, mapping[type], className)} style={styles} disabled={disabled}>
            {!!IconComponent && (
                <IconComponent className="h-6 w-6 mr-2" />
            )}
            {children}
        </button>
    );
};

export default Button;
